import { select } from '@ps/web-core-store';
import React from 'react';
import { useSelector } from 'react-redux';

import { Country } from '@swf/core/enums';
import useWizardContext from '@swf/core/hooks/useWizardContext';

import BrazilIcon from '../../assets/rg_br_v2.jpg';
import SpadeIcon from '../../assets/rg_generic_spade_v2.jpg';
import { CashierFlowType } from '../../types/Cashier';

import { imageCashierContainer, imageContainer } from './ResponsibleGamingImage.scss';

const ResponsinbleGamingImage = () => {
  const country = useSelector(select.account.getCountry) as Country;

  const {
    data: { cashierFlow }
  } = useWizardContext();
  const isCashierFlow = cashierFlow?.includes(
    CashierFlowType.FirstWithdraw || CashierFlowType.FirstDeposit
  );
  return (
    <div className={isCashierFlow ? imageCashierContainer : imageContainer}>
      <img alt="Welcome" src={country === Country.Brazil ? BrazilIcon : SpadeIcon} width="100%" />
    </div>
  );
};
export default ResponsinbleGamingImage;
